<template>
  <div class="ScoreReports">
    <div class="header">
      <div class="timePicker">
        <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-item has-feedback>
            <a-select
              v-model="academic"
              :default-value="timePicker[timePicker.length - 1]"
            >
              <a-select-option
                :value="item"
                v-for="(item, index) in timePicker"
                :key="index"
              >
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <div class="content">
      <div class="series">
        <div class="seriesTitle">{{ $t('report.reportCard') }}</div>
        <div class="tableData">
          <a-table
            tableLayout="fixed"
            :loading="tableLoading"
            :data-source="reportCard"
            :pagination="false"
            :rowKey="reportCard => reportCard.id"
          >
            <a-table-column
              :title="$t('report.academicYear')"
              dataIndex="academic"
            ></a-table-column>
            <a-table-column :title="$t('report.grade')" dataIndex="grade">
              <template slot-scope="grade">
                <p>{{ grade == 9 ? 'pre-10' : grade }}</p>
              </template>
            </a-table-column>
            <a-table-column
              :title="$t('report.report')"
              dataIndex="reportName"
            ></a-table-column>
            <a-table-column :title="$t('report.status')" dataIndex="status">
              <template slot-scope="status">
                <a-tag :color="status == '1' ? 'green' : 'red'">
                  {{ status == 1 ? 'open' : 'close' }}
                </a-tag>
              </template>
            </a-table-column>
            <a-table-column
              :title="$t('report.finalOperatingTime')"
              dataIndex="finalOperatingTime"
            ></a-table-column>
            <a-table-column :title="$t('report.operate')" dataIndex="operate">
              <template slot-scope="status, reportCard">
                <a @click="btnSwitch(reportCard.id, reportCard.status)">
                  {{ reportCard.status == 0 ? 'open' : 'close' }}
                </a>
              </template>
            </a-table-column>
          </a-table>
        </div>
      </div>
      <div class="series">
        <div class="seriesTitle">{{ $t('report.officialTranscript') }}</div>
        <a-table
          tableLayout="fixed"
          :rowKey="reportCard => reportCard.id"
          :loading="tableLoading"
          :data-source="officialTranscript"
          :pagination="false"
        >
          <a-table-column
            :title="$t('report.academicYear')"
            dataIndex="academic"
          ></a-table-column>
          <a-table-column :title="$t('report.grade')" dataIndex="grade">
            <template slot-scope="grade">
              <p>{{ grade == 9 ? 'pre-10' : grade }}</p>
            </template>
          </a-table-column>
          <a-table-column
            :title="$t('report.report')"
            dataIndex="reportName"
          ></a-table-column>
          <a-table-column :title="$t('report.status')" dataIndex="status">
            <template slot-scope="status">
              <a-tag :color="status == '1' ? 'green' : 'red'">
                {{ status == 1 ? 'open' : 'close' }}
              </a-tag>
            </template>
          </a-table-column>
          <a-table-column
            :title="$t('report.finalOperatingTime')"
            dataIndex="finalOperatingTime"
          ></a-table-column>
          <a-table-column :title="$t('report.operate')" dataIndex="operate">
            <template slot-scope="status, reportCard">
              <a @click="btnSwitch(reportCard.id, reportCard.status)">
                {{ reportCard.status == 0 ? 'open' : 'close' }}
              </a>
            </template>
          </a-table-column>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      timePicker: [],
      columns: [],
      academic: null,
      tableLoading: true,
      reportCard: [],
      officialTranscript: []
    }
  },
  created() {
    //获取年份数据
    const timePicker = this.$store.state.dataManage.academicYearList
    this.timePicker = timePicker
    this.academic = this.timePicker[timePicker.length - 1]
  },
  methods: {
    getScoreReports(data) {
      this.$http(this.$api.GETSCOREREPORTS, data, 'get').then(r => {
        this.reportCard = r.data.reportCard
        this.officialTranscript = r.data.officialTranscript
        this.tableLoading = false
      })
    },
    //关闭或者开启学生得成绩报告
    switch(data) {
      this.$http(this.$api.SWITCHCHREPORTCAR, data, 'post').then(r => {
        if (r.code == 0) {
          //success
          this.tableLoading = true
          let data = { academic: this.academic }
          this.getScoreReports(data)
        }
      })
    },
    btnSwitch(id, status) {
      let that = this
      this.$confirm({
        title:
          status == 0
            ? this.$t('report.reportCardTipsOpen')
            : this.$t('report.reportCardTipsClose'),
        onOk() {
          let data = {
            id,
            status: status == 1 ? 0 : 1
          }
          that.switch(data)
        },
        onCancel() {}
      })
    }
  },
  watch: {
    academic(val) {
      let data = { academic: val }
      this.getScoreReports(data)
    }
  }
}
</script>
<style scoped lang="less">
.ScoreReports {
  width: calc(100%);
  height: 100vh;
  // padding-right: 40px;
  box-sizing: border-box;
  // overflow: scroll;
  .header {
    margin-top: 10px;
    padding-left: 10px;
    width: 300px;
    height: 50px;
    box-sizing: border-box;
  }
  .content {
    width: 100%;
    height: calc(100% - 50px);
    padding: 0 10px;
    box-sizing: border-box;
    .series {
      width: 100%;
      .seriesTitle {
        width: 100%;
        font-size: 15px;
        height: 60px;
        line-height: 60px;
        font-weight: 500;
      }
    }
  }
}
</style>
